import ReactDOM from 'react-dom';
import './index.css';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { ApolloProvider } from '@apollo/client';
import React, { useState } from 'react';
import { Grid, Hidden, Box } from '@material-ui/core';
import MenuPagina from './menuPagina';
import MenuMovil from './menuPagina/Movil';

const Header = () => {
    //Para implementacion de menu on mobile
    const [drawerOpen, setDrawerOpen] = useState(false);
    const toggleDrawer = () => setDrawerOpen(false);
    const openDrawer = () => setDrawerOpen(true);

    return (
        <>
            <Box width="auto" style={{ backgroundColor: "#f0efef" }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                >
                    <Hidden only={['lg', 'md', 'xl']}>
                        <MenuMovil openDrawer={openDrawer} toggleDrawer={toggleDrawer} drawerOpen={drawerOpen} />
                    </Hidden>
                </Grid>
            </Box>
            <Box width="auto" style={{ padding: "8px 0px 0px" }} >
                <Hidden only={['xs', 'sm']}>
                    <Grid item sm={12}>
                        <MenuPagina />
                    </Grid>
                </Hidden>
            </Box>
        </>
    )
}

/* URL GRAPHQL */
//produccion --> https://prod-graphql.utic.ecosur.mx/graphql
//desarrollo --> https://dev-graphql.utic.ecosur.mx/graphql

const client = new ApolloClient({
    uri: "https://prod-graphql.utic.ecosur.mx/graphql",
    cache: new InMemoryCache()
});

ReactDOM.render(
    <React.StrictMode>
        <ApolloProvider client={client}>
            <Header />
        </ApolloProvider>
    </React.StrictMode>,
    document.getElementById('menu-principal-infonomia')
);

export default Header;